export const translations = {
  fr: {
    nav: {
      home: 'ACCUEIL',
      destinations: 'NOS DESTINATIONS',
      whyUs: 'POURQUOI NOUS CHOISIR',
      contact: 'CONTACT',
      reserve: 'RÉSERVER'
    },
    hero: {
      title: 'BRUTAXI',
      subtitle: 'Service Taxi Professionnel à Bruxelles',
      description: 'Réservation en ligne 24h/24 • Tarifs transparents',
      tags: 'Belgique • Belgium • België',
      reservationTitle: 'Réservation Immédiate',
      pickupPlaceholder: 'Adresse de prise en charge à Bruxelles',
      destinationPlaceholder: 'Votre destination en Belgique ou Europe',
      reserveButton: 'Réserver Mon Taxi Maintenant',
      features: 'Confirmation immédiate • Paiement sécurisé • Chauffeur agréé'
    },
    whyUs: {
      title: 'Pourquoi Nous Choisir',
      subtitle: 'Votre confort et sécurité sont notre priorité',
      feature1Title: 'Service 24h/24 - 7j/7',
      feature1Desc: 'Réservez un taxi à toute heure, même pour les vols de nuit. Disponible à toute heure, tous les jours de l\'année pour vos déplacements urgents ou planifiés.',
      feature2Title: 'Chauffeurs Professionnels Agréés',
      feature2Desc: 'Sécurité maximale avec des professionnels certifiés par la région. Tous nos chauffeurs sont agréés, expérimentés et connaissent parfaitement le réseau routier belge.',
      feature3Title: 'Tarifs Fixes et Transparents',
      feature3Desc: 'Calculateur de prix en ligne sans frais cachés. Prix fixe annoncé à l\'avance, pas de supplément bagages ni de mauvaise surprise à l\'arrivée.',
      feature4Title: 'Véhicules Haut de Gamme',
      feature4Desc: 'Flotte moderne, confortable et bien entretenue. Du véhicule économique au prestige, tous équipés pour votre confort et adaptés à vos besoins.',
      feature5Title: 'Réservation Instantanée',
      feature5Desc: 'Réservez en ligne en quelques clics, 24h/24. Confirmation immédiate par email et SMS pour votre tranquillité d\'esprit.',
      feature6Title: 'Paiement Flexible et Sécurisé',
      feature6Desc: 'Plusieurs options de paiement disponibles : espèces ou carte bancaire. Paiement sécurisé directement auprès du chauffeur à la fin de votre course.'
    },
    destinations: {
      title: 'Nos Destinations Populaires',
      subtitle: 'Nous vous conduisons partout en Belgique et en Europe',
      airport: 'Navette Aéroport Belgique',
      airportDesc: 'Transfert personnalisé vers Brussels Airport (Zaventem), Charleroi (Brussels South) et Liège Airport. Arrivée garantie à l\'heure, 24h/24. Suivi de vol inclus pour vous accueillir à la sortie des bagages.',
      cities: 'Transport Privé Grandes Villes',
      citiesDesc: 'Déplacements inter-city entre Bruxelles, Anvers, Gand et Liège. Idéal pour vos rendez-vous d\'affaires ou sorties touristiques. Trajets rapides avec connaissance parfaite du réseau routier belge.',
      europe: 'Transferts Internationaux Europe',
      europeDesc: 'Voyagez sans contraintes vers Paris, Amsterdam, Luxembourg et Cologne. Véhicules haut de gamme pour trajets longue distance. Tarif fixe et transparent pour toute l\'Europe, pas de surprise à la frontière.',
      stations: 'Navette Gares de Bruxelles',
      stationsDesc: 'Correspondance garantie pour Eurostar et Thalys. Gare du Midi, Gare Centrale et Gare du Nord. Chauffeur à quai pour une transition fluide vers votre destination finale.'
    },
    contact: {
      title: 'Contactez-Nous',
      subtitle: 'Notre équipe est à votre disposition',
      email: 'Email',
      phone: 'Téléphone',
      address: 'Adresse',
      addressValue: 'Bruxelles, Belgique',
      hours: 'Horaires',
      hoursValue: '24h/24 - 7j/7',
      namePlaceholder: 'Votre nom',
      emailPlaceholder: 'Votre email',
      messagePlaceholder: 'Votre message',
      sendButton: 'Envoyer le message'
    },
    footer: {
      company: 'Taxi Bel SPRL',
      description: 'Service de taxi professionnel à Bruxelles et en Belgique',
      quickLinks: 'Liens Rapides',
      legal: 'Mentions Légales',
      privacy: 'Politique de Confidentialité',
      terms: 'Conditions Générales',
      rights: '© 2025 BRUTAXI. Tous droits réservés.'
    },
    languageModal: {
      title: 'Choisissez votre langue',
      french: 'Français',
      dutch: 'Nederlands',
      english: 'English'
    },
    booking: {
      vehicles: {
        eco: 'Eco - Véhicule standard',
        business: 'Business - Véhicule premium',
        van: 'Van - 7-8 places',
        prestige: 'Prestige - Véhicule de luxe',
        pmr: 'PMR - Adapté handicap'
      },
      passengerSingular: 'passager',
      passengerPlural: 'passagers',
      luggageSingular: 'bagage',
      luggagePlural: 'bagages',
      extraLuggageLabel: 'Supplément bagages',
      paymentModeLabel: 'Mode de paiement (au chauffeur)',
      paymentCash: 'Espèces',
      paymentCard: 'Carte bancaire',
      calculatePriceButton: 'Calculer le Prix',
      calculatingPrice: 'Calcul en cours...',
      estimatedPrice: 'Prix estimé',
      submitting: 'Envoi en cours...',
      confirmButton: 'Confirmer',
      confirmationTitle: 'Réservation confirmée',
      confirmationSubtitle: 'Votre réservation a été enregistrée avec succès.',
      bookingNumber: 'Numéro de réservation',
      rideDetails: 'Détails de la Course',
      pickup: 'Prise en charge:',
      destination: 'Destination:',
      date: 'Date:',
      time: 'Heure:',
      informations: 'Informations',
      passengers: 'Passagers:',
      vehicle: 'Véhicule:',
      payment: 'Paiement:',
      estimatedFare: 'Tarif estimé',
      needHelp: 'Besoin d\'aide ?',
      phone: 'Téléphone:',
      email: 'Email:',
      driverOnTime: 'Notre chauffeur sera à l\'heure au point de rendez-vous.',
      telegramNotification: 'Vous recevrez bientôt nos informations par Telegram.',
      closeButton: 'Fermer'
    }
  },
  nl: {
    nav: {
      home: 'HOME',
      destinations: 'ONZE BESTEMMINGEN',
      whyUs: 'WAAROM ONS KIEZEN',
      contact: 'CONTACT',
      reserve: 'RESERVEREN'
    },
    hero: {
      title: 'BRUTAXI',
      subtitle: 'Professionele Taxidienst in Brussel',
      description: 'Online reserveren 24/7 • Transparante tarieven',
      tags: 'België • Belgium • Belgique',
      reservationTitle: 'Directe Reservering',
      pickupPlaceholder: 'Ophaaladres in Brussel',
      destinationPlaceholder: 'Bestemming in België of Europa',
      reserveButton: 'Reserveer Nu Mijn Taxi',
      features: 'Onmiddellijke bevestiging • Veilige betaling • Erkende chauffeur'
    },
    whyUs: {
      title: 'Waarom Ons Kiezen',
      subtitle: 'Uw comfort en veiligheid zijn onze prioriteit',
      feature1Title: 'Service 24/7',
      feature1Desc: 'Reserveer een taxi op elk moment, zelfs voor nachtvluchten. Beschikbaar op elk moment, elke dag van het jaar voor uw dringende of geplande verplaatsingen.',
      feature2Title: 'Professionele Erkende Chauffeurs',
      feature2Desc: 'Maximale veiligheid met door de regio gecertificeerde professionals. Al onze chauffeurs zijn erkend, ervaren en kennen het Belgische wegennet perfect.',
      feature3Title: 'Vaste en Transparante Tarieven',
      feature3Desc: 'Online prijscalculator zonder verborgen kosten. Vaste prijs vooraf aangekondigd, geen bagagetoeslag of verrassingen bij aankomst.',
      feature4Title: 'High-End Voertuigen',
      feature4Desc: 'Moderne, comfortabele en goed onderhouden vloot. Van economisch tot prestige voertuig, allemaal uitgerust voor uw comfort.',
      feature5Title: 'Onmiddellijke Reservering',
      feature5Desc: 'Reserveer online in enkele klikken, 24/7. Onmiddellijke bevestiging per e-mail en SMS voor uw gemoedsrust.',
      feature6Title: 'Flexibele en Veilige Betaling',
      feature6Desc: 'Meerdere betaalmogelijkheden beschikbaar: contant of bankkaart. Veilige betaling rechtstreeks aan de chauffeur aan het einde van uw rit.'
    },
    destinations: {
      title: 'Onze Populaire Bestemmingen',
      subtitle: 'We rijden u overal naartoe in België en Europa',
      airport: 'Luchthaven Shuttle België',
      airportDesc: 'Gepersonaliseerde transfer naar Brussels Airport (Zaventem), Charleroi (Brussels South) en Liège Airport. Gegarandeerde aankomst op tijd, 24/7. Vluchtopvolging inbegrepen om u bij bagage op te halen.',
      cities: 'Privétransport Grote Steden',
      citiesDesc: 'Inter-city verplaatsingen tussen Brussel, Antwerpen, Gent en Luik. Ideaal voor uw zakelijke afspraken of toeristische uitstapjes. Snelle trajecten met perfecte kennis van het Belgische wegennet.',
      europe: 'Internationale Transfers Europa',
      europeDesc: 'Reis zonder beperkingen naar Parijs, Amsterdam, Luxemburg en Keulen. High-end voertuigen voor lange afstanden. Vaste en transparante prijs voor heel Europa, geen verrassingen aan de grens.',
      stations: 'Shuttle Brusselse Stations',
      stationsDesc: 'Gegarandeerde aansluiting voor Eurostar en Thalys. Zuidstation, Centraal Station en Noordstation. Chauffeur op het perron voor een vlotte overgang naar uw eindbestemming.'
    },
    contact: {
      title: 'Contacteer Ons',
      subtitle: 'Ons team staat tot uw beschikking',
      email: 'E-mail',
      phone: 'Telefoon',
      address: 'Adres',
      addressValue: 'Brussel, België',
      hours: 'Openingsuren',
      hoursValue: '24/7',
      namePlaceholder: 'Uw naam',
      emailPlaceholder: 'Uw e-mail',
      messagePlaceholder: 'Uw bericht',
      sendButton: 'Verstuur bericht'
    },
    footer: {
      company: 'Taxi Bel SPRL',
      description: 'Professionele taxidienst in Brussel en België',
      quickLinks: 'Snelle Links',
      legal: 'Wettelijke Vermeldingen',
      privacy: 'Privacybeleid',
      terms: 'Algemene Voorwaarden',
      rights: '© 2025 BRUTAXI. Alle rechten voorbehouden.'
    },
    languageModal: {
      title: 'Kies uw taal',
      french: 'Français',
      dutch: 'Nederlands',
      english: 'English'
    },
    booking: {
      vehicles: {
        eco: 'Eco - Standaard voertuig',
        business: 'Business - Premium voertuig',
        van: 'Van - 7-8 plaatsen',
        prestige: 'Prestige - Luxe voertuig',
        pmr: 'PMR - Aangepast voor gehandicapten'
      },
      passengerSingular: 'passagier',
      passengerPlural: 'passagiers',
      luggageSingular: 'bagage',
      luggagePlural: 'bagages',
      extraLuggageLabel: 'Bagage supplement',
      paymentModeLabel: 'Betaalwijze (aan chauffeur)',
      paymentCash: 'Contant',
      paymentCard: 'Bankkaart',
      calculatePriceButton: 'Prijs Berekenen',
      calculatingPrice: 'Berekening bezig...',
      estimatedPrice: 'Geschatte prijs',
      submitting: 'Verzenden...',
      confirmButton: 'Bevestigen',
      confirmationTitle: 'Reservering bevestigd',
      confirmationSubtitle: 'Uw reservering is succesvol geregistreerd.',
      bookingNumber: 'Reserveringsnummer',
      rideDetails: 'Rit Details',
      pickup: 'Ophalen:',
      destination: 'Bestemming:',
      date: 'Datum:',
      time: 'Tijd:',
      informations: 'Informatie',
      passengers: 'Passagiers:',
      vehicle: 'Voertuig:',
      payment: 'Betaling:',
      estimatedFare: 'Geschat tarief',
      needHelp: 'Hulp nodig?',
      phone: 'Telefoon:',
      email: 'E-mail:',
      driverOnTime: 'Onze chauffeur zal op tijd zijn op de afspraakplaats.',
      telegramNotification: 'U ontvangt binnenkort onze informatie via Telegram.',
      closeButton: 'Sluiten'
    }
  },
  en: {
    nav: {
      home: 'HOME',
      destinations: 'OUR DESTINATIONS',
      whyUs: 'WHY CHOOSE US',
      contact: 'CONTACT',
      reserve: 'BOOK NOW'
    },
    hero: {
      title: 'BRUTAXI',
      subtitle: 'Professional Taxi Service in Brussels',
      description: 'Online booking 24/7 • Transparent rates',
      tags: 'Belgium • Belgique • België',
      reservationTitle: 'Immediate Booking',
      pickupPlaceholder: 'Pickup address in Brussels',
      destinationPlaceholder: 'Destination in Belgium or Europe',
      reserveButton: 'Book My Taxi Now',
      features: 'Immediate confirmation • Secure payment • Licensed driver'
    },
    whyUs: {
      title: 'Why Choose Us',
      subtitle: 'Your comfort and safety are our priority',
      feature1Title: '24/7 Service',
      feature1Desc: 'Book a taxi at any time, even for night flights. Available at any time, every day of the year for your urgent or planned trips.',
      feature2Title: 'Licensed Professional Drivers',
      feature2Desc: 'Maximum safety with region-certified professionals. All our drivers are licensed, experienced and know the Belgian road network perfectly.',
      feature3Title: 'Fixed and Transparent Rates',
      feature3Desc: 'Online price calculator with no hidden fees. Fixed price announced in advance, no luggage supplement or surprises on arrival.',
      feature4Title: 'High-End Vehicles',
      feature4Desc: 'Modern, comfortable and well-maintained fleet. From economy to prestige vehicle, all equipped for your comfort.',
      feature5Title: 'Instant Booking',
      feature5Desc: 'Book online in a few clicks, 24/7. Immediate confirmation by email and SMS for your peace of mind.',
      feature6Title: 'Flexible and Secure Payment',
      feature6Desc: 'Multiple payment options available: cash or credit card. Secure payment directly to the driver at the end of your ride.'
    },
    destinations: {
      title: 'Our Popular Destinations',
      subtitle: 'We take you anywhere in Belgium and Europe',
      airport: 'Belgium Airport Shuttle',
      airportDesc: 'Personalized transfer to Brussels Airport (Zaventem), Charleroi (Brussels South) and Liège Airport. Guaranteed on-time arrival, 24/7. Flight tracking included to meet you at baggage claim.',
      cities: 'Private Transport Major Cities',
      citiesDesc: 'Inter-city travel between Brussels, Antwerp, Ghent and Liège. Ideal for your business meetings or tourist outings. Fast routes with perfect knowledge of the Belgian road network.',
      europe: 'International Transfers Europe',
      europeDesc: 'Travel without constraints to Paris, Amsterdam, Luxembourg and Cologne. High-end vehicles for long-distance journeys. Fixed and transparent price for all Europe, no surprises at the border.',
      stations: 'Brussels Train Stations Shuttle',
      stationsDesc: 'Guaranteed connection for Eurostar and Thalys. Brussels-South, Central and North stations. Driver waiting at platform for smooth transition to your final destination.'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Our team is at your disposal',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      addressValue: 'Brussels, Belgium',
      hours: 'Hours',
      hoursValue: '24/7',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'Your email',
      messagePlaceholder: 'Your message',
      sendButton: 'Send message'
    },
    footer: {
      company: 'Taxi Bel SPRL',
      description: 'Professional taxi service in Brussels and Belgium',
      quickLinks: 'Quick Links',
      legal: 'Legal Notice',
      privacy: 'Privacy Policy',
      terms: 'Terms and Conditions',
      rights: '© 2025 BRUTAXI. All rights reserved.'
    },
    languageModal: {
      title: 'Choose your language',
      french: 'Français',
      dutch: 'Nederlands',
      english: 'English'
    },
    booking: {
      vehicles: {
        eco: 'Eco - Standard vehicle',
        business: 'Business - Premium vehicle',
        van: 'Van - 7-8 seats',
        prestige: 'Prestige - Luxury vehicle',
        pmr: 'PMR - Handicap adapted'
      },
      passengerSingular: 'passenger',
      passengerPlural: 'passengers',
      luggageSingular: 'luggage',
      luggagePlural: 'luggage',
      extraLuggageLabel: 'Extra luggage',
      paymentModeLabel: 'Payment method (to driver)',
      paymentCash: 'Cash',
      paymentCard: 'Credit card',
      calculatePriceButton: 'Calculate Price',
      calculatingPrice: 'Calculating...',
      estimatedPrice: 'Estimated price',
      submitting: 'Submitting...',
      confirmButton: 'Confirm',
      confirmationTitle: 'Booking confirmed',
      confirmationSubtitle: 'Your booking has been successfully registered.',
      bookingNumber: 'Booking number',
      rideDetails: 'Ride Details',
      pickup: 'Pickup:',
      destination: 'Destination:',
      date: 'Date:',
      time: 'Time:',
      informations: 'Information',
      passengers: 'Passengers:',
      vehicle: 'Vehicle:',
      payment: 'Payment:',
      estimatedFare: 'Estimated fare',
      needHelp: 'Need help?',
      phone: 'Phone:',
      email: 'Email:',
      driverOnTime: 'Our driver will be on time at the meeting point.',
      telegramNotification: 'You will soon receive our information via Telegram.',
      closeButton: 'Close'
    }
  }
};